import script from "./PublicationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationsList.vue?vue&type=script&setup=true&lang=js"

import "./PublicationsList.vue?vue&type=style&index=0&id=2197b7b9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2197b7b9"]])

export default __exports__